import React, { FC } from 'react';
import styled from 'styled-components';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';

import { buttonVariants } from '@clatter/ui';
import { NgButton } from '../NgButton/NgButton';

interface FormButtonsProps {
  isLoading: boolean;
  isDirty: boolean;
  isValid: boolean;
  reset: () => void;
}

const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;

  .right-side {
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    gap: 15px;
  }
`;

export const FormButtons: FC<FormButtonsProps> = ({ isLoading, isDirty, isValid, reset }) => {
  return (
    <StyledButtonsContainer>
      <div className="left-side">
        <NgButton
          disabled={isLoading || !isDirty}
          icon={ClearIcon}
          variant={buttonVariants.clear}
          onClick={() => reset()}
          type="reset"
          testId="dynamic-form-reset-button"
        >
          Reset
        </NgButton>
      </div>
      <div className="right-side">
        <NgButton
          disabled={isLoading || !isDirty || !isValid}
          icon={DoneIcon}
          type="submit"
          variant={buttonVariants.primary}
          testId="dynamic-form-submit-button"
          onClick={() => console.log('')}
        >
          Submit
        </NgButton>
      </div>
    </StyledButtonsContainer>
  );
};
